import React from 'react';
import { useNavigate } from 'react-router-dom';
import CommonButton from '../../../common/components/CommonButton';
import { CommonButtonVariants } from '../../../constants/CommonButtonVariants';
import nextGearOrnament from '../../../assets/img/nextGear/next-gear-ornament.svg';
import { NEXT_GEAR_CAPITAL_URL } from '../../constants';
import RouterPaths from '../../../constants/RouterPaths';

function NextGearCardsSection() {
  const navigate = useNavigate();

  const cards = [
    {
      title: 'Already a NextGear Capital customer?',
      text: 'You can use your facility right away on The Stock Vault.',
      button: {
        label: 'Login to the Stock Vault',
        onClick: () => {
          navigate(RouterPaths.LOGIN);
        },
      },
    },
    {
      title: 'New to NextGear Capital?',
      text: 'Apply now to set up your facility and start funding purchases.',
      button: {
        label: 'Apply with NextGear Capital',
        onClick: () => {
          window.open(NEXT_GEAR_CAPITAL_URL);
        },
      },
    },
  ];

  return (
    <section className="ng-cards">
      <div className="ng-cards__container">
        <div className="ng-cards__inner">
          <div className="ng-cards__content">
            <ul className="ng-cards__list">
              {cards.map(({ title, text, id, button }) => (
                <li key={id} className="ng-cards__card-item">
                  <div className="ng-cards__card-item-content">
                    <h4 className="ng-cards__card-item-title">{title}</h4>
                    <p className="ng-cards__card-item-text">{text}</p>
                    <CommonButton
                      label={button.label}
                      className="ng-cards__button"
                      variant={CommonButtonVariants.RED}
                      handleClick={button.onClick}
                    />
                  </div>
                </li>
              ))}
            </ul>
            <img src={nextGearOrnament} alt="NextGear ornament" className="ng-cards__icon" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default NextGearCardsSection;
